import React from "react";
import "@fortawesome/fontawesome-free/css/all.min.css";

const LuxuryCarOne = () => {
  const features = [
    {
      title: "On-Time Service",
      text: "Aaradhya Travels provides punctual pickup and drop services for local and outstation travel needs.",
      delay: "100ms",
    },
    {
      title: "Comfort & Safety",
      text: "Travel comfortably with clean vehicles, professional drivers, and reliable customer support.",
      delay: "300ms",
    },
  ];

  const carImages = [
    // "/images/fleets/Force-Urbania.jpg",
    "/images/urbani.png",
  ];

  return (
    <section
      className="luxury-car-one luxury-car-one--two section-space pt-0 pt-2"
      style={{
        overflowX: "hidden",
        overflowY: "hidden",
      }}
    >
      <div className="container">
        <div className="row align-items-center">

          {/* Left Content */}
          <div className="col-lg-6">
            <div className="luxury-car-one__content">

              <div className="sec-title sec-title--two text-start">
                <h6 className="sec-title__tagline">
                  AARADHYA TRAVELS
                </h6>

                <h3 className="sec-title__title">
                  Enjoy Safe & Comfortable Travel With Us
                </h3>
              </div>

              <p
                className="luxury-car-one__text wow fadeInUp"
                data-wow-duration="1500ms"
                data-wow-delay="100ms"
              >
                Aaradhya Travels offers premium travel solutions including
                Tempo Travellers, Urbania, Mini Buses, Airport Transfers,
                Corporate Travel, Family Tours, Wedding Transportation, and
                Outstation Trips. We are committed to delivering comfort,
                safety, reliability, and exceptional customer service on
                every journey.
              </p>

              <div className="luxury-car-one__feature mt-4">
                {features.map((feature, index) => (
                  <div
                    key={index}
                    className="luxury-car-one__feature__list d-flex mb-4 wow fadeInUp"
                    data-wow-duration="1500ms"
                    data-wow-delay={feature.delay}
                  >
                    <div
                      className="luxury-car-one__feature__list__icon me-3"
                      style={{
                        width: "55px",
                        height: "55px",
                        minWidth: "55px",
                        borderRadius: "50%",
                        background: "#ff3600",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        color: "#fff",
                        fontSize: "20px",
                      }}
                    >
                      <i className="fas fa-check"></i>
                    </div>

                    <div className="luxury-car-one__feature__list__content">
                      <h5 className="luxury-car-one__feature__list__title">
                        {feature.title}
                      </h5>

                      <p className="luxury-car-one__feature__list__text">
                        {feature.text}
                      </p>
                    </div>
                  </div>
                ))}
              </div>

            </div>
          </div>

          {/* Right Side Image */}
          <div className="col-lg-6">
            <div
              className="luxury-car-one__carousel wow fadeInRight"
              data-wow-duration="1500ms"
              data-wow-delay="300ms"
              style={{
                overflow: "hidden",
                borderRadius: "20px",
                position: "relative",
              }}
            >
              <div
                className="luxury-car-one__carousel__bg"
                style={{
                  backgroundImage:
                    "url('/images/resources/car-carousel-bg.png')",
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                  borderRadius: "20px",
                }}
              ></div>

              <div className="row">
                {carImages.map((image, index) => (
                  <div className="col-12" key={index}>
                    <div className="luxury-car-one__item text-center">
                      <img
                        src={image}
                        alt={`Aaradhya Travels ${index + 1}`}
                        className="img-fluid"
                        style={{
                          maxWidth: "100%",
                          height: "auto",
                          display: "block",
                          margin: "0 auto",
                        }}
                      />
                    </div>
                  </div>
                ))}
              </div>

            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default LuxuryCarOne;